import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import OtherService from "services/OtherService";
export const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchLoyaltyData = createAsyncThunk(
  "other/fetchLoyaltyData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await OtherService.getLoyalty();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const updateLoyaltyData = createAsyncThunk(
  "other/updateLoyaltyData",
  async (data, { rejectWithValue }) => {
    try {
      const { value } = data;
      const response = await OtherService.updateLoyalty({ value });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const otherSlice = createSlice({
  name: "other",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoyaltyData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoyaltyData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchLoyaltyData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateLoyaltyData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateLoyaltyData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateLoyaltyData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { showLoading } = otherSlice.actions;

export default otherSlice.reducer;
